import { createStyles } from 'antd-style'

export const useStyle = createStyles({
  cardTask: {
    minHeight: 385
  }
})
